<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Podsumowanie</h2>
        </section>
        <section class="step-item__body rows">
            <section class="step-item__body__item">
                <Card>
                    <CardHeader>Wybrane grupy użytkowników ({{selectedGroups.length}})</CardHeader>
                    <CardBody>
                        <ul>
                            <li v-for="(item, index) in selectedGroups" :key="index">{{ item.id }} {{ item.name }}</li>
                        </ul>
                    </CardBody>
                </Card>
                <Card v-if="this.$store.state.wizardNewCadence.clientHasTransmission">
                    <CardHeader>Wybrane ustawienia</CardHeader>
                    <CardBody>
                        <span>Ustawienie transmisji: <span style="font-weight: bold">{{ this.$store.state.wizardNewCadence.transmissionSettings === true ? 'Tak' : 'Nie' }}</span></span>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>Wybrane grupy kontaktów ({{selectedGroupsWithoutSession.length}})</CardHeader>
                    <CardBody>
                        <ul>
                            <li v-for="(item, index) in selectedGroupsWithoutSession" :key="index">{{ item.id }} {{ item.name }}<span v-if="isCopyWithContacts(item)">, wraz z kontaktami ({{ item.availablePeople.length }})</span></li>
                        </ul>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>Wybrani administratorzy ({{ selectedAdministrators.length }})</CardHeader>
                    <CardBody>
                        <ul>
                            <li v-for="(item, index) in selectedAdministrators" :key="index">{{ item.firstName }} {{ item.lastName }}</li>
                        </ul>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>Wybrane szablony ({{ selectedTemplates.length }})</CardHeader>
                    <CardBody>
                        <ul>
                            <li v-for="(item, index) in selectedTemplates" :key="index">{{ item.signature }}</li>
                        </ul>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>Wybrani użytkownicy ({{this.$store.state.wizardNewCadence.usersList.length}}/{{this.$store.state.wizardNewCadence.availablelicences}})</CardHeader>
                    <CardBody>
                        <perfect-scrollbar style="max-height:300px">
                            <ul>
                                <li v-for="(item, index) in $store.state.wizardNewCadence.usersList" :key="index">{{ item.name }} {{ item.surname }}</li>
                            </ul>
                        </perfect-scrollbar>
                    </CardBody>
                </Card>
            </section>
        </section>
        <section class="step-item__footer" v-if="this.$store.state.wizardNewCadence.allSuccess === false">
            <ButtonWithIcon :icon="'additional-arrow'" :text="'Wstecz'" class="btn-step-item btn-reverse" @click="movePrev" />

            <ButtonWithIcon v-if="allStepsFullfill"
                            :icon="'save'"
                            :text="'Utwórz nową kadencję'"
                            class="btn-step-item btn-reverse"
                            @click="$store.commit('setModalConfirmCreateNewCadenceStatus', true)" />
            <ButtonWithIcon v-else
                            v-tooltip="'Nie wszystkie kroki zostały wypełnione'"
                            :disabled="true"
                            :icon="'save'"
                            text="Utwórz nową kadencję"
                            class="btn-step-item btn-reverse" />

        </section>
        <Transition>
            <ConfirmSetupNewCadenceModal v-if="this.$store.state.wizardNewCadence.modalConfirmCreateNewCadence" />
        </Transition>
    </section>
</template>
<script charset="utf-8">
    import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
    import ConfirmSetupNewCadenceModal from "../components/ConfirmSetupNewCadenceModal.vue";

    export default {
        name: "Step5Users",
        components: {
            ButtonWithIcon,
            ConfirmSetupNewCadenceModal
        },
        computed: {
            missingSteps() {
                return this.$store.state.wizardNewCadence.requiredSteps.filter(item => !this.$store.state.wizardNewCadence.stepsDone.includes(item));
            },
            allStepsFullfill() {
                return this.missingSteps.length === 0;
            }
        },
        data() {
            return {
                allSelectedGroups: [],
                selectedGroups: [],
                selectedGroupsWithoutSession: [],
                selectedAdministrators: [],
                selectedTemplates: [],
            }
        },
        async mounted() {
            try {
                this.allSelectedGroups = wizardNewCadenceService.allSelectedGroups();
                this.selectedGroups = wizardNewCadenceService.selectedGroups();
                this.selectedGroupsWithoutSession = wizardNewCadenceService.selectedGroupsWithoutSession();
                this.selectedAdministrators = wizardNewCadenceService.selectedAdministrators();
                this.selectedTemplates = wizardNewCadenceService.selectedTemplates();

                if (this.$store.state.wizardNewCadence.clientHasTransmission === false) {
                    this.$store.state.wizardNewCadence.requiredSteps = this.$store.state.wizardNewCadence.requiredSteps.filter(item => item !== 2);
                }

                this.$store.commit("setWizardNewCadenceBusyStatus", true);
                this.$store.commit("setWizardNewCadenceCurrentStep", 6);

            }
            finally {
                this.$store.commit("setWizardNewCadenceBusyStatus", false);
            }
        },
        methods: {

            async movePrev() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 5 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 5);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            isCopyWithContacts(item) {
                if (item === undefined || item === null)
                    return false;

                return this.$store.state.wizardNewCadence.selectedContactGroups.includes(item.id);
            }
        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";

    .rows {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        .toolbar{
            display: flex;
            flex-direction: row;
            justify-content:space-between
        }
    }

    .step-item__body__item{
        display: flex;
        flex-direction: row;
        column-gap: 20px;
        row-gap:20px;
        flex-wrap: wrap;
        
        .card{
            max-width: 400px;
        }
    }
</style>
